import React from 'react';
import { Container, Popup } from './styles';
import { useDropdown } from './../hooks/useDropdown';

const DropdownContent = ({ children, id: _id, containerId, width, style, content }) => {
  const { isOpen, position, dropdownRef, initiatorRef, handleMouseOver, handleMouseLeave } =
    useDropdown();

  return (
    <Container
      ref={initiatorRef}
      style={style}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      <Popup
        ref={dropdownRef}
        open={isOpen}
        id={containerId}
        className="asset-popup"
        width={width}
        style={{ top: position.top, left: position.left }}
      >
        {content}
      </Popup>
    </Container>
  );
};

export default DropdownContent;
